import { Toaster } from './toast';

export class ErrorHandler {
    public static errorResponseHandler(error: any) {
        // if has response show the error
        if (error.response.status === 500) {
            window.HideLoader();
            Toaster.error('An error occurred in the system');
            return Promise.reject(error);
        } else if (error.response.status === 409) {
            window.HideLoader();
            Toaster.error(error.response.data);
            return Promise.reject(error);
        }
    }
}
